import React, { useState, useCallback, useMemo } from "react";
import { useWorklog } from "../../../../utils/reactQuery/worklog";
import ListWorklog from "./listWorklog";
import "./worklog.scss";
import AddWorklogCustomizedDialogs from "./addWorklog/addWorklogDialog";
import Loader from "../../../../components/Loader";
import { useCard } from "../../../../utils/reactQuery/cards";
import { currentUserId, isAdmin } from "../../../../utils/constants";
import NoWorklog from "./noWorklog/noWorklog";
import MoveWorklog from "./MoveWorklog";
import { CustomButton } from "../../../../components/Button/Button";

const ShowWorklog = ({ cardId, textEditor, boardPermission, isMobile=false , addWorklogPermission }) => {
  const [addWorklog, setAddWorklog] = useState(false);
  const { card } = useCard(cardId);

  const {
    assigned_to_user_id,
    board: { owner_user_id: boardOwnerId },
    is_card_collaborator,
  } = card?.data?.data?.responseData;

  const { isLoading: isWorklogLoading, worklog } = useWorklog(cardId);


  const handleAddWorklog = useCallback(() => {
    if (addWorklogPermission) {
      setAddWorklog(true);
    }
  }, [addWorklogPermission]);

  const moveWorklogPermission = useMemo(
    () =>
      isAdmin() || boardOwnerId == currentUserId() || boardPermission?.is_admin || (boardPermission?.can_move_edit_work_log && currentUserId() == assigned_to_user_id),
    [boardOwnerId, boardPermission]
  );
  // || boardPermission?.can_move_edit_work_log;

  const sortWorklogsByDateDescending = useCallback((worklogs) => {
    if (worklogs && worklogs.length > 0) {
      return worklogs.sort(
        (a, b) => new Date(b.worklog_time) - new Date(a.worklog_time)
      );
    } else {
      return [];
    }
  }, []);

  const sortedWorklogs = useMemo(
    () => sortWorklogsByDateDescending(worklog?.data?.data?.responseData),
    [worklog, sortWorklogsByDateDescending]
  );

  return (
    <>
      {!worklog?.data?.data?.responseData[0] || textEditor
        ? null
        : !isMobile && (
            <div className="add-worklog-btn">
              <CustomButton
                onClick={handleAddWorklog}
                disabled={!addWorklogPermission}
                variant="contained"
              >
                Add Work Log
              </CustomButton>
            </div>
          )}
      {addWorklog && (
        <AddWorklogCustomizedDialogs
          cardId={cardId}
          addWorklog={addWorklog}
          setAddWorklog={setAddWorklog}
          heading={"Add Work Log"}
          buttonName={"Save"}
        />
      )}
      {worklog?.data?.data?.responseData[0] && moveWorklogPermission && (
        <div className="d-flex justify-content-end align-items-center mt-4">
          <p>Select target task:</p>
          <MoveWorklog cardId={cardId} />
        </div>
      )}
      {isWorklogLoading ? (
        <div className="worklog-loader">
          <Loader color={"black"} />
        </div>
      ) : worklog?.data?.data?.responseData[0] ? (
        sortedWorklogs.map((data, index) => (
          <ListWorklog
            key={`worklog-list-item-${index}`}
            data={data}
            cardId={cardId}
            moveWorklogPermission={moveWorklogPermission}
            boardPermission={boardPermission}
            boardOwnerId={boardOwnerId}
          />
        ))
      ) : (
        <NoWorklog cardId={cardId} premission={addWorklogPermission} />
      )}
    </>
  );
};

export default React.memo(ShowWorklog);
